import { apiClient } from '../api';
import { fail } from './common.actions';
import { METHOD } from '../api/constants';

// TODO customModelMethod !! Changed, maybe all this changes
export const modelGet = (model, history, errorsCallback, customModelMethod) => {
    return modelActionCall(model, history, errorsCallback, METHOD.GET, customModelMethod);
};

export const modelPost = (model, history, errorsCallback) => {
    return modelActionCall(model, history, errorsCallback, METHOD.POST);
};

export const modelActionCall = (model, history, errorsCallback, requestMethodName = METHOD.GET, customModelMethod = null) => {
    const apiClientInstance = apiClient();

    const clientApiMethod = requestMethodName === METHOD.GET ? apiClientInstance.get : apiClientInstance.post;

    let modelApiMethod = requestMethodName === METHOD.GET ? model.apiGet : model.apiPost;

    modelApiMethod = customModelMethod || modelApiMethod;

    return model.actionApiCall(clientApiMethod.bind(apiClientInstance), modelApiMethod.bind(model), model, history, fail(errorsCallback), requestMethodName);
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/actions/model.actions.js